import { render } from "./AppLoader.vue?vue&type=template&id=5bea5538"
const script = {}

import "./AppLoader.vue?vue&type=style&index=0&id=5bea5538&lang=scss"

import exportComponent from "C:\\Users\\niso\\Documents\\repos\\storyworld-everhouse-touchkit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__